'use client'

import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { CogIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import ToolInfoTable from "./ToolInfoTable"
import { XMarkIcon } from '@heroicons/react/24/solid'
const toolData = [
    {
        img: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png", // آیکون نمونه
        id: " 1",
        date: "22/3/1403",
        budget: "true",
        completion: 80,
        fullname:"زهرا عباسی",
        productName:"B45",
        count:4,
        TrackingCode:"34566c5"
    },
    {
        img: "https://cdn-icons-png.flaticon.com/512/2910/2910767.png",
        id: " 2",
        date: "22/8/1403",
        budget: "false",
        completion: 60,
        fullname:"علی رضایی",
        productName:"A12",
        count:15,
        TrackingCode:"5566h88"
    },
    {
        img: "https://cdn-icons-png.flaticon.com/512/2910/2910760.png",
        id: " 3",
        date: "25/05/1404",
        budget: "true",
        completion: 100,
        fullname:"احمد پورعباس",
        productName:"A22",
        count:34,
        TrackingCode:"4686p87"
    },
    {
        img: "https://cdn-icons-png.flaticon.com/512/2910/2910743.png",
        id: " 4",
        date: "22/8/1403",
        type: "boolean",
        budget: "true",
        completion: 45,
        fullname:"مریم کریمی",
        productName:"C45",
        count:23,
        TrackingCode:"75775u98"
    },
];



export default function ToolPreView({ open, setOpen }) {
    //   const [open, setOpen] = useState(true)

    return (
        <div>
            {/* <button
        onClick={() => setOpen(true)}
        className="rounded-md bg-gray-950/5 px-2.5 py-1.5 text-sm font-semibold text-gray-900 hover:bg-gray-950/10"
      >
        Open dialog
      </button> */}
            <Dialog open={open} onClose={() => setOpen(false)} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all 
                            data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 
                            data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full
                             sm:max-w-3xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            <div className="bg-gray-50 px-4 py-3 flex flex-row justify-between items-center sm:px-6">
                                {/* <button
                                    type="button"
                                    onClick={() => setOpen(false)}
                                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                >
                                  بستن
                                
                                </button> */}
                                
                                <div className="flex  size-12 shrink-0 items-center justify-center rounded-full bg-[#aadec5] sm:mx-0 sm:size-10">
                                    <CogIcon className="h-5 w-5 text-gray-700" aria-hidden="true" />
                                    
                                </div>
                                <h3 className="text-base font-semibold text-gray-900 hidden sm:inline-block">
                                        مشخصات ابزار
                                    </h3>
                                
                                
                                <button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setOpen(false)}
                                    className="mt-3 inline-flex w-12     justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                >
                                    <XMarkIcon className="w-6 h-6 text-red-500" />
                                </button>
                            </div>
                            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                    {/* <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-[#aadec5] sm:mx-0 sm:size-10">
                                        <CogIcon className="h-5 w-5 text-gray-700" aria-hidden="true" />

                                    </div> */}
                                    <div className="mt-3 text-center flex justify-center items-center">
                                        <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                                            {/* مشخصات ابزار */}
                                        </DialogTitle>
                                        <div className="mt-2 mx-auto flex justify-center items-center w-full">
                                            <ToolInfoTable data={toolData} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}
